import { Component, Input, ViewChild } from '@angular/core';

import { IonicPage, NavController, NavParams, AlertController, ViewController, ActionSheetController } from 'ionic-angular';

import { BarcodeScanner } from '@ionic-native/barcode-scanner';

import { OperadorCaixasPage } from '../operador-caixas/operador-caixas';

import { Tools, User, Api, SyncIO } from '../../providers';

@IonicPage()
@Component({
  selector: 'page-operador-packing',
  templateUrl: 'operador-packing.html',
})

export class OperadorPackingPage {
  @ViewChild('inputQtd') inputQtd ;
  @ViewChild('inputCode') inputCode ;

  conectado:boolean = true;

  isReadyToSave: any=false;
  trocarProd: any=false;
  showMotivo: any=false;
  showNewProd: any=false;
  prodPesavel: any=false;

  separacao: any;
  idx: any;
  type: any;
  motivo: any;
  code: any;
  itensList: any;
  itensOpts: any;

  newQtd:any="";
  newObs:string="";
  newProd:string="Nome do novo Produto";

  caixas: any = [];
  reqs:any = [];

  postObj:any = {};

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private barcodeScanner: BarcodeScanner,
    public alertCtrl: AlertController,
    public tools: Tools,
    public sync: SyncIO,
    public api: Api,
    public user: User,
    public viewCtrl: ViewController,
    public actionSheetCtrl: ActionSheetController,
  ){
    this.idx = navParams.get('idx');
    this.separacao = navParams.get('separacao');
    this.caixas = this.separacao.caixas.find(e=>e.codigo == this.separacao.items[this.idx].codigo);

    for(let item of this.separacao.items){
      if(!item.conferido){item.conferido=false}
      if(!item.caixa){item.caixa=''}
    }

    this.separacao.items[this.idx].caixa = this.caixas.caixa;

    this.itensOpts = {
      title: 'Seleção de Caixas'
    }

    this.itensList = [];

    this.caixas.caixas.map(caixa=>{
      this.itensList.push({value:caixa,text:caixa});
    });

  }

  ionViewDidLoad(){
    // console.clear();

    console.log('ionViewDidLoad OperadorPackingPage');
    console.log(this.reqs);

    setTimeout(() => {
      if(this.inputQtd){
        this.inputQtd.setFocus();
      }else{
        this.inputCode.setFocus();
      }
    },500);
  }

  getCode(field:any,func:any){
    this.barcodeScanner.scan().then(barcodeData => {
      this.code = barcodeData.text+'';

      if(func){
        this[func]();
      }

    }).catch(err => {
      console.log('Error', err);
    });
  }

  setCode(){
    console.log(this.code);

    //Trat campo em branco
    if(!this.code || this.code == ''){
      this.isReadyToSave = false;
    }

    // Processo Normal
    else if(!this.showNewProd){
      if(this.separacao.items[this.idx].codigoBarra == this.code && this.newQtd){
        this.isReadyToSave = true;
        this.separacao.items[this.idx].conferido = true;
      }else{
        this.isReadyToSave = false;
      }
    }

    //Troca de produto
    else if(this.showNewProd){
      this.buscarProduto(this.code);
    }
  }

  setQtdPesavel(){
    if(!this.newQtd || this.newQtd == ''){
      this.isReadyToSave = false;
    }else if(!this.showNewProd){
      if((this.code || this.separacao.items[this.idx].codigoBarra.length < 6) && this.separacao.items[this.idx].codigoBarra && this.newQtd){
        console.log(this.newQtd);
        this.isReadyToSave = true;
      }
      this.prodPesavel = true;
      this.newQtd = this.mascaraPeso(this.newQtd);
    }else{
      this.isReadyToSave = true;
    }
  }

  mascaraPeso(value){
    var v = value;
    var integer = v.split(',')[0];

    v = v.replace(/\D/, "");
    v = v.replace(/^[0]+/, "");

    if(v.length <= 3 || !integer){
      if(v.length === 1) v = v;
      if(v.length === 2) v = v;
      if(v.length === 3) v = v;
      if(v.length === 4) v = v;
    }else{
      v = v.replace(/^(\d{1,})(\d{4})$/, "$1.$2");
    }

    return v;
  }

  setCaixa(){
    this.separacao.items[this.idx].caixa = this.caixas.caixa;
  }

  setQtd(){
    console.log(this.newQtd);
    console.log(isNaN(parseFloat(this.newQtd)));

    if(isNaN(parseFloat(this.newQtd))){
      this.isReadyToSave = false;
      return;
    }else if(this.trocarProd){
      this.isReadyToSave = true;
    }
  }

  addCaixas(){
    console.log(this.separacao);
    this.navCtrl.push(OperadorCaixasPage,{separacao:this.separacao});
  }

  actionFalta(){
    var removeProd = false;
    let selectMotivo = this.alertCtrl.create({
      title: 'Selecione um Motivo',
      inputs: [
        {type: 'radio', label: 'Desistencia', value: 'Desistencia', checked:true},
        {type: 'radio', label: 'Falta', value: 'Falta'},
        {type: 'radio', label: 'Outros', value: 'Outros'}
      ],
      buttons: [
        {
          text: 'OK',
          handler: motivo => {
            console.log('teste ok',motivo);
            this.separacao.items[this.idx].motivo = motivo;
            if(!removeProd){
              this.showNewProd = true
            }else{
              this.removerItem((result)=>{
                if(result.status){
                  this.separacao.items[this.idx].cancelado = true;
                  this.tools.showAlert('toast',`${this.separacao.items[this.idx].produto} - Removido`,2000);
                  this.viewCtrl.dismiss(this.separacao.items);
                }else{
                  console.log(result);
                  this.tools.showAlert('toast',`Erro`,2000);
                }
              });
            }
          }
        }
      ]
    });

    const actionSheet = this.actionSheetCtrl.create({
      title: 'Outras Ações',
      buttons: [
        {
          text: 'Adicionar Caixa',
          icon: 'md-cube',
          handler: () => {
            this.addCaixas();
            console.log('Adicionar Caixa clicked');
          }
        },
        // {
        //   text: 'Substituir Produto',
        //   icon: 'ios-repeat',
        //   handler: () => {
        //     selectMotivo.present();
        //     console.log('Substituir Produto clicked');
        //   }
        // },
        {
          text: 'Remover Produto',
          icon: 'trash',
          handler: () => {
            let confirm = this.alertCtrl.create({
              title: 'Confirmação',
              message: 'Deseja realmete remover o produto ?',
              buttons: [
                { text: 'Não', handler: () => { return } },
                {
                  text: 'Sim',
                  handler: () => {
                    removeProd = true;
                    selectMotivo.present();
                  }
                }
              ]
            });
            confirm.present();
            console.log('Remover Produto clicked');
          }
        },
        {
          text: 'Sair',
          role: 'cancel',
          icon: 'close',
          handler: () => {
            console.log('Cancelar clicked');
          }
        }
      ]
    });
    actionSheet.present();
  }

  modificarItem(callback){
    var loading = this.tools.showLoading('Carregando');
    loading.present();

    this.postObj.separacaoId = this.separacao._id;
    this.postObj.pedido = this.separacao.items[this.idx].codigo;
    this.postObj.modificarProduto = {
      "quantidade": parseFloat(this.newQtd),
      "desistencia": false,
      "indisponivel": false,
      "id_pedido_item":this.separacao.items[this.idx].id,
      "pedido":this.separacao.items[this.idx].codigo
    }

    let self = this;
    var url = 'http://barbosa.ibrs.com.br:5000/api/tracking/upditem';

    this.conectado = this.tools.getStatusOnline();

    if(this.conectado){
      this.sendPost(url,(result)=>{
        console.log(result);

        if(result.status){
          if(result.modificarProduto.status){
            var prodId = result.modificarProduto.produtoId;
            var idx = self.separacao.items.findIndex(e=>e.id == prodId);
            if(idx>=0){
              loading.dismiss();

              var prodSM = result.pedidoSM.items.find(e=>e.id  == result.modificarProduto.produtoId);

              self.separacao.items[idx].conferido = true;
              self.separacao.items[idx].desistencia = prodSM.desistencia;
              self.separacao.items[idx].indisponivel = prodSM.indisponivel;
              self.separacao.items[idx].quantidade = prodSM.quantidade;
              self.separacao.items[idx].quantidade3 = prodSM.quantidade3;

              callback({status:true, code:result.modificarProduto.code, produto:self.separacao.items[idx].produto, msg:result.modificarProduto.msg || 'Alterado !'});
            }else{
              loading.dismiss();
              callback({status:false, msg:'Produto não encontrado no Pedido'});
            }
          }else{
            loading.dismiss();
            callback({status:false, msg:'Erro ao Modificar Produto'});
          }
        }else{
          loading.dismiss();
          console.log('Deu ruim integração modificarItem',result);
          callback({status:false, msg:'Erro na integração, tente novamente'});
        }

      });
    }else{
      this.reqs.push({
        url:url,
        tipo:'update',
        req:{... this.postObj}
      });
      console.log(this.reqs);

      loading.dismiss();

      callback({status:false, msg:'Você está desconetado. As alterações serão feitas ao finalizar a separação'});
    }

  }

  removerItem(callback){
    var loading = this.tools.showLoading('Carregando');
    loading.present();

    this.postObj.separacaoId = this.separacao._id;
    this.postObj.pedido = this.separacao.items[this.idx].codigo;
    this.postObj.modificarProduto = {
      "quantidade": 0,
      "desistencia": this.separacao.items[this.idx].motivo == 'Desistencia' ? true : false,
      "indisponivel": this.separacao.items[this.idx].motivo == 'Falta' ? true : false,
      "id_pedido_item":this.separacao.items[this.idx].id,
      "pedido":this.separacao.items[this.idx].codigo
    }

    let self = this;
    var url = 'http://barbosa.ibrs.com.br:5000/api/tracking/upditem';

    this.conectado = this.tools.getStatusOnline();
    if(this.conectado){
      this.sendPost(url,(result)=>{
        console.log(result);

        if(result.status){
          if(result.modificarProduto.status){
            var prodId = result.modificarProduto.produtoId;
            var idx = self.separacao.items.findIndex(e=>e.id == prodId);
            if(idx>=0){
              var pedSM = result.pedidoSM;
              var prodSM = result.pedidoSM.items.find(e=>e.id  == result.modificarProduto.produtoId);

              self.separacao.items[idx].desistencia = prodSM.desistencia;
              self.separacao.items[idx].indisponivel = prodSM.indisponivel;
              self.separacao.items[idx].quantidade = prodSM.quantidade;
              self.separacao.items[idx].quantidade3 = prodSM.quantidade3;
              self.separacao.items[idx].cancelado = true;

              if(self.separacao.items.length != pedSM.items.length){
                pedSM.items.map(e=>{
                  if(!self.separacao.items.find(f=>f.id == e.id)){
                    e.conferido = true;
                    e.cancelado = e.desistencia || e.indisponivel ? true : false;
                    self.separacao.items.push(e);
                  }
                });
              }

              loading.dismiss();
              callback({status:true,code:result.modificarProduto.code, msg:result.modificarProduto.msg || 'Alterado 1!'});
            }else{
              loading.dismiss();
              callback({status:false, msg:'Produto não encontrado no Pedido'});
            }
          }else{
            loading.dismiss();
            callback({status:false, msg:'Erro ao Remover Produto'});
          }
        }else{
          loading.dismiss();
          callback({status:false, msg:'Erro na integração, tente novamente'});
          console.log('Deu ruim integração removerItem',result);
        }
      });
    }else{
      this.separacao.items[this.idx].cancelado = true;

      this.reqs.push({
        url:url,
        tipo:'remove',
        req:{... this.postObj}
      });

      loading.dismiss();

      callback({status:false, conectado:false, msg:'Você está desconetado. As alterações serão feitas ao finalizar a separação'});
    }
  }

  adicionarItem(callback){
    console.log('adicionarItem');

    var loading = this.tools.showLoading('Carregando');
    loading.present();

    this.postObj.separacaoId = this.separacao._id;
    this.postObj.pedido = this.separacao.items[this.idx].codigo;
    this.postObj.adicionarProduto = {
      "codigoBarra": this.code,
      "quantidade": this.mascaraPeso(this.newQtd),
      "unitario": true,
      "pedido":this.separacao.items[this.idx].codigo
    }

    let self = this;
    var url = 'http://barbosa.ibrs.com.br:5000/api/tracking/upditem';

    this.conectado = this.tools.getStatusOnline();
    if(this.conectado){
      this.sendPost(url,(result)=>{
        console.log(result);

        if(result.status){
          if(result.adicionarProduto.status){
            var prodSM = result.pedidoSM.items.find(e=>e.codigoBarra  == result.adicionarProduto.codigoBarras);

            prodSM.conferido = true;
            prodSM.caixa = this.caixas.caixa;
            prodSM.img = this.separacao.items[this.idx].img;

            self.separacao.items.push(prodSM);

            loading.dismiss();
            callback({status:true,code:result.adicionarProduto.code, msg:result.adicionarProduto.msg, produto:prodSM.produto});
          }else{
            loading.dismiss();
            callback({status:false, msg:result.adicionarProduto.msg});
          }
        }else{
          console.log('Deu ruim integração adicionarItem',result);
          loading.dismiss();
          callback({status:false, msg:'Erro na integração, tente novamente'});
        }

      });
    }else{
      this.reqs.push({
        url:url,
        tipo:'insert',
        req:{... this.postObj}
      });

      loading.dismiss();

      callback({status:false, conectado:false, msg:'Você está desconetado. As alterações serão feitas ao finalizar a separação'});
    }

  }

  sendPost(url,callback){
    var self = this;
    this.api.sendPost(url,self.postObj,{},function(result){
      callback(result);
    });
  }

  buscarProduto(codigoBarra){
    this.conectado = this.tools.getStatusOnline();
    if(this.conectado){
      var loading = this.tools.showLoading('Carregando');
      loading.present();

      let self = this;
      var urlBuscarProdutos = 'http://barbosa.ibrs.com.br:5000/api/tracking/buscarproduto';

      this.postObj = {sku:codigoBarra};

      this.sendPost(urlBuscarProdutos,(result)=>{
        console.log(result);

        if(result.status && result.data){
          self.newProd = result.data.nome;
          // self.isReadyToSave = true;
          self.trocarProd = true;

          self.buscarProdutoImg(codigoBarra, loading);
          // loading.dismiss();
        }else{
          self.tools.showAlert('toast',`${result.msg}`,1500);
          loading.dismiss();
        }
      });
    }else{
      this.trocarProd = true;
      this.tools.showAlert('toast','Você está desconetado. As alterações serão feitas ao finalizar a separação',2000);
    }
  }

  buscarProdutoImg(codigoBarra, loading){
    // var loading = this.tools.showLoading('Carregando');
    // loading.present();

    let self = this;
    var urlBuscarProdutos = 'http://barbosa.ibrs.com.br:5000/api/tracking/buscarprodutosimg';

    this.postObj = {codigos:[codigoBarra]};

    this.sendPost(urlBuscarProdutos,(result)=>{
      console.log(result);

      if(result.status && result.data && result.data.length>0){
        for(var x1 in result.data){
          this.separacao.items[this.idx].img = `http://barbosa.ibrs.com.br:4032/gridfs/${this.user.getSession()}/download/fileProdutos/${result.data[x1].linkId}/-1`;
          console.log(`http://barbosa.ibrs.com.br:4032/gridfs/${this.user.getSession()}/download/fileProdutos/${result.data[x1].linkId}/-1`);
        }

        setTimeout(() => {
          loading.dismiss();
        }, 500);

      }else{
        this.separacao.items[this.idx].img = false;

        self.tools.showAlert('toast',`${result.msg}`,1500);
        loading.dismiss();
      }
    });
  }

  cancel(){
    let confirm = this.alertCtrl.create({
      title: 'Confirmação',
      message: 'Deseja realmete voltar a tela anterior ?',
      buttons: [
        {
          text: 'Não',
          handler: () => {
            return
          }
        },
        {
          text: 'Sim',
          handler: () => {
            this.viewCtrl.dismiss(this.separacao.items);
            this.tools.showAlert('toast',`${this.separacao.items[this.idx].produto} - Cancelado`,2000);
          }
        }
      ]
    });
    confirm.present();
  }

  doneOnline(){
    var self = this;
    console.log(this.separacao.items[this.idx].quantidade);
    console.log(this.newQtd);


    //Produto Pesavel
    if(this.prodPesavel && this.separacao.items[this.idx].quantidade != this.newQtd/1000){
      console.log('Produto Pesavel');

      this.modificarItem((result)=>{
        if(result.status){
          self.tools.showAlert('toast',`1 ${result.produto} - Modificado`,2000);
          self.viewCtrl.dismiss(self.separacao.items);
        }else{
          self.tools.showAlert('toast',`2 ${result.msg}`,2000);
        }
      });
    }

    //Substituir Produto
    if(this.trocarProd){
      console.log('Substituir Produto');

      if(isNaN(this.newQtd) || this.newQtd == ''){
        this.tools.showAlert('toast',`Digite uma Quantidade Válida`,2000);
        return;
      }else{
        this.removerItem((result0)=>{
          if(result0.status){
            self.adicionarItem((result)=>{
              if(result.status){
                self.tools.showAlert('toast',`1- ${result.produto} - Adicionado`,2000);
                self.viewCtrl.dismiss(self.separacao.items);
              }else{
                self.tools.showAlert('toast',`2- ${result.msg}`,2000);
              }
            });
          }else{
            self.tools.showAlert('toast',`3- ${result0.msg}`,2000);
          }
        });
      }
    }

    //Processo Normal
    else if(!this.prodPesavel || this.separacao.items[this.idx].quantidade == this.newQtd/1000){
      console.log('Processo Normal')
      if((this.separacao.items[this.idx].conferido || this.separacao.items[this.idx].codigoBarra.length < 6) && this.caixas.caixa != ''){
        this.separacao.items[this.idx].conferido = true;
        this.tools.showAlert('toast',`${this.separacao.items[this.idx].produto} - Separado`,2000);
        this.viewCtrl.dismiss(this.separacao.items);
      }else{
        let confirm = this.alertCtrl.create({
          title: 'Alerta',
          message: 'Preencha Corretamente os Dados',
          buttons: [ { text: 'OK', handler: () => { return } } ]
        });
        confirm.present();
      }
    }
  }

  doneOffline(){
    var self = this;

    //Produto Pesavel
    if(this.prodPesavel && this.separacao.items[this.idx].quantidade != this.newQtd/1000){
      console.log('Produto Pesavel');

      this.modificarItem((result)=>{
        if(!result.conectado){
          self.tools.showAlert('toast',`1 ${result.msg}`,2000);
          self.viewCtrl.dismiss(self.separacao.items, self.reqs);
        }else{
          self.tools.showAlert('toast',`2 ${result.msg}`,2000);
        }
      });
    }

    //Substituir Produto
    if(this.trocarProd){
      console.log('Substituir Produto');

      if(isNaN(this.newQtd) || this.newQtd == ''){
        this.tools.showAlert('toast',`Digite uma Quantidade Válida`,2000);
        return;
      }else{
        this.removerItem((removeResult)=>{
          if(!removeResult.conectado){
            self.adicionarItem((addResult)=>{
              if(!addResult.conectado){
                console.log(this.reqs);

                self.tools.showAlert('toast',`1- ${addResult.msg}`,2000);
                self.viewCtrl.dismiss(self.separacao.items, this.reqs);
              }else{
                self.tools.showAlert('toast',`2- ${addResult.msg}`,2000);
              }
            });
          }else{
            self.tools.showAlert('toast',`3- ${removeResult.msg}`,2000);
          }
        });
      }
    }

    //Processo Normal
    else if(!this.prodPesavel || this.separacao.items[this.idx].quantidade == this.newQtd/1000){
      console.log('Processo Normal')
      if((this.separacao.items[this.idx].conferido || this.separacao.items[this.idx].codigoBarra.length < 6) && this.caixas.caixa != ''){
        this.separacao.items[this.idx].conferido = true;
        this.tools.showAlert('toast',`${this.separacao.items[this.idx].produto} - Separado`,2000);
        this.viewCtrl.dismiss(this.separacao.items);
      }else{
        let confirm = this.alertCtrl.create({
          title: 'Alerta',
          message: 'Preencha Corretamente os Dados',
          buttons: [ { text: 'OK', handler: () => { return } } ]
        });
        confirm.present();
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/operador-packing/operador-packing.ts